<template>
  <div>
    <el-dialog :title="`【${info.courseName}】类目管理`" :visible.sync="dialogVisible" width="500px"
      :close-on-click-modal="false">
      <div style="display: flex;column-gap: 10px;margin-bottom: 10px;">
        <el-input v-model="form.categoryName" placeholder="请输入类目名称" />
        <el-button type="primary" @click="addItem()">新增</el-button>
      </div>
      <el-table :data="tableData" border>
        <el-table-column prop="categoryName" label="分类名称">
          <template v-slot="scope">
            <div v-if="!scope.row.editing" style="display: flex;align-items: center;column-gap: 5px;cursor: pointer;"
              @click="editItem(scope.row)">
              <span>{{ scope.row.categoryName }}</span>
              <i class="el-icon-edit"></i>
            </div>
            <el-input size="small" v-else v-model="scope.row.categoryNameNew" placeholder="请输入类目名称"
              @change="changeItem(scope.row)" @blur="changeItem(scope.row)" />
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template v-slot="scope">
            <el-button type="text" @click="deleteItem(scope.row.categoryId)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      info: {},
      courseId: null,
      tableData: [],
      form: {},
    }
  },
  methods: {
    open(info) {
      this.info = info
      this.courseId = info.id
      this.getList()
      this.dialogVisible = true
    },
    async getList() {
      const res = await this.$request.get("/cms/courseChapters/getChapterList?courseId=" + this.courseId)
      if (res.data.code === 200) {
        this.tableData = res.data.data || []
      }
    },
    async addItem() {
      if (!this.form.categoryName) {
        this.$message.warning("请输入类目名称")
        return
      }
      const res = await this.$request.post("/cms/video_categories/add", {
        ...this.form,
        courseId: this.courseId
      })
      if (res.data.code === 200) {
        this.$message.success("操作成功")
        this.form = {}
        this.getList()
      }
    },
    async deleteItem(id) {
      const res = await this.$request.get("/cms/video_categories/delete_id?id=" + id)
      if (res.data.code === 200) {
        this.$message.success("操作成功")
        this.getList()
      }
    },
    editItem(row) {
      this.$set(row, "categoryNameNew", row.categoryName)
      this.$set(row, "editing", true)
    },
    async changeItem(row) {
      console.log("11")
      this.$set(row, "editing", false)
      if (row.categoryNameNew === row.categoryName) {
        return
      }
      const res = await this.$request.post("/cms/video_categories/edit", {
        categoryId: row.categoryId,
        categoryName: row.categoryNameNew,
      })
      if (res.data.code === 200) {
        this.$message.success("修改成功")
        this.getList()
      }
    }
  },
};
</script>